import { c as _c } from "react/compiler-runtime";
import { TAGS_API } from 'modules/tags/api/tags-api';
import { TagFilterInterface } from 'modules/tags/types/tag-filter-interface';
import { TagApiInterface, TagStatisticApiInterface } from 'modules/tags/types/tag-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
interface UseTagsInterface extends SwrPaginationInterface {
  filter: TagFilterInterface;
}
export function useTags(t0) {
  const $ = _c(23);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher: listFetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: statisticsFetcher
  } = useFetch(t2);
  let t3;
  if ($[2] !== filter || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t3 = () => user && [`${TAGS_API}/listing?${getPaginationAndFilterQueryString({
      pagination,
      limit,
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Tags, RequestModuleEnum.TagsListing];
    $[2] = filter;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: tags,
    mutate
  } = useControlledSwr(t3, listFetcher, undefined, undefined);
  let t4;
  if ($[7] !== filter || $[8] !== limit || $[9] !== pagination || $[10] !== user) {
    t4 = () => user && [`${TAGS_API}/statistics?${getPaginationAndFilterQueryString({
      pagination,
      limit,
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Tags, RequestModuleEnum.TagsStatistics];
    $[7] = filter;
    $[8] = limit;
    $[9] = pagination;
    $[10] = user;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    data: tagsStatistics
  } = useControlledSwr(t4, statisticsFetcher, undefined, undefined);
  let t5;
  if ($[12] !== filter || $[13] !== user) {
    t5 = () => user && [`${TAGS_API}/count?${getFilterQueryString({
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Tags, RequestModuleEnum.TagsCounter];
    $[12] = filter;
    $[13] = user;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    data: counter
  } = useControlledSwr(t5, baseFetcher, undefined, undefined);
  let t6;
  if ($[15] !== revalidateModules) {
    t6 = hardRevalidate => {
      revalidateModules([RequestModuleEnum.Tags], hardRevalidate);
    };
    $[15] = revalidateModules;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const revalidateTagsModule = t6;
  let t7;
  if ($[17] !== counter || $[18] !== mutate || $[19] !== revalidateTagsModule || $[20] !== tags || $[21] !== tagsStatistics) {
    t7 = {
      tags,
      tagsStatistics,
      mutate,
      counter,
      revalidateTagsModule
    };
    $[17] = counter;
    $[18] = mutate;
    $[19] = revalidateTagsModule;
    $[20] = tags;
    $[21] = tagsStatistics;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}